/** @format */

import {Dispatch, SetStateAction} from 'react';

import {IconButton} from '@mui/material';

import {Close, KeyboardArrowDown, KeyboardArrowUp} from '@mui/icons-material';
import {Trans} from 'react-i18next';

import {AnalyticGoalsFromQuery, FunnelGoal, GoalsFromQuery} from '../../interfaces';
import {
  ErrorText,
  LevelActions,
  LevelContent,
  LevelDropdownArea,
  LevelItem,
  LevelRight,
  LevelSubtitle,
} from './styles';

interface Props {
  goal: FunnelGoal;
  index: number;
  setSelectedGoals: Dispatch<SetStateAction<GoalsFromQuery>>;
  allAnalyticGoals: AnalyticGoalsFromQuery;
  isAnalyticGoalsLoaded: boolean;
}

const SelectedGoal = ({
  goal,
  index,
  setSelectedGoals,
  allAnalyticGoals,
  isAnalyticGoalsLoaded,
}: Props) => {
  const handleRemoveGoal = (goalId: number) => {
    setSelectedGoals(prev => prev.filter((g: FunnelGoal) => g.id !== goalId));
  };

  const moveGoal = (index: number, direction: 'up' | 'down') => {
    setSelectedGoals(prev => {
      const next = [...prev];
      const targetIndex = direction === 'up' ? index - 1 : index + 1;
      if (targetIndex < 0 || targetIndex >= next.length) return prev;
      const tmp = next[index];
      next[index] = next[targetIndex];
      next[targetIndex] = tmp;
      return next;
    });
  };

  return (
    <LevelItem key={goal.id}>
      <LevelActions>
        <IconButton onClick={() => moveGoal(index, 'up')} size='small'>
          <KeyboardArrowUp />
        </IconButton>
        <IconButton onClick={() => moveGoal(index, 'down')} size='small'>
          <KeyboardArrowDown />
        </IconButton>
      </LevelActions>

      <LevelContent>
        <LevelSubtitle>{goal.name}</LevelSubtitle>
        <LevelSubtitle>№ {goal.id}</LevelSubtitle>
        {isAnalyticGoalsLoaded && !allAnalyticGoals.some(g => g.id === goal.id) && (
          <ErrorText>
            <Trans>Отсутствует в подключенном счетчике</Trans>
          </ErrorText>
        )}
      </LevelContent>

      <LevelDropdownArea>
        <KeyboardArrowDown sx={{opacity: 0.6}} />
      </LevelDropdownArea>

      <LevelRight>
        <IconButton onClick={() => handleRemoveGoal(goal.id)} size='small'>
          <Close />
        </IconButton>
      </LevelRight>
    </LevelItem>
  );
};

export default SelectedGoal;
